/**
 * Central check for the Eigenmarken rollout feature flag.
 *
 * The flag is provided via the build-time env var
 * `GATSBY_EIGENMARKEN_ROLLOUT_ENABLED` and is considered enabled only when it
 * equals the string `'true'`.
 *
 * @returns {boolean} `true` when the Eigenmarken rollout is enabled.
 */
export const isEigenmarkenRolloutEnabled = () =>
  process.env.GATSBY_EIGENMARKEN_ROLLOUT_ENABLED === 'true'
